import { createFileRoute } from "@tanstack/react-router";
import Pricings from "@/components/Pricings";
// import { ScrollPromoGrowthDialog } from "@/components/providers/scroll-promo-growth-dialog";
import { getUserGeoData } from "@/lib/geo.server";

export const Route = createFileRoute("/$lang/pricings")({
  loader: async () => {
    const geoData = await getUserGeoData();
    return { geoData };
  },
  component: LangPricingsPage,
});

function LangPricingsPage() {
  const { geoData } = Route.useLoaderData();

  return (
    <>
      <main className="relative z-10 w-full min-w-0 bg-background pt-24 sm:pt-28">
        <Pricings countryCode={geoData.countryCode} currency={geoData.currency} />
      </main>
      {/* <ScrollPromoGrowthDialog /> */}
    </>
  );
}
